import {
    PRINT_GROUPS_STORAGE_KEY,
    PRINT_GROUP_TTL_MS,
} from '../constants/print'

export const loadPrintGroups = () => {
    try {
        const data = localStorage.getItem(PRINT_GROUPS_STORAGE_KEY)
        return data ? JSON.parse(data) : {}
    } catch (error) {
        console.error(
            '[PrintGroupsStorage] Ошибка при загрузке групп печати:',
            error
        )
        return {}
    }
}

export const savePrintGroups = groups => {
    try {
        localStorage.setItem(PRINT_GROUPS_STORAGE_KEY, JSON.stringify(groups))
    } catch (error) {
        console.error(
            '[PrintGroupsStorage] Ошибка при сохранении групп печати:',
            error
        )
    }
}

export const clearPrintGroups = () => {
    localStorage.removeItem(PRINT_GROUPS_STORAGE_KEY)
}

/**
 * Удаляет устаревшие группы печати (старше PRINT_GROUP_TTL_MS)
 */
export const cleanupExpiredGroups = groups => {
    const now = Date.now()
    const cleaned = {}

    Object.entries(groups).forEach(([groupId, group]) => {
        if (now - group.createdAt < PRINT_GROUP_TTL_MS) {
            cleaned[groupId] = group
        }
    })

    return cleaned
}
